import React, { useContext, useState, useCallback, useMemo } from 'react'
import { Button, ModalBody, ModalFooter } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useQsDataTable as useDataTable } from 'react-use-datatable/react'
import {
  DownloadOrdiniFornitori,
  FornitoriState,
  OrdiniFornitoreState,
} from './localstate'
import Paginator from '../../components/Paginator'
import ModalUpdateStato from '../../components/Planner/ModalUpdateStato'
import DateRangeQsFilter from '../../components/Planner/DateRangeQsFilter'
import Column from '../../components/Column'
import { ConfigPlannerContext } from '../../context'
import { PERMISSIONS } from '../../django'
import { Modal, ModalHeader } from 'reactstrap'
import OrderFornitoreForm from '../../components/Planner/OrderFornitoreForm'
import { getFasiNeededByOrder } from './localstate/common'
import { ContextFornitori, ContextFornitoriActions } from './contexts'
import { useRj, useRunRj } from 'react-rocketjump'
import moment from 'moment'
import { CircularProgress } from '@material-ui/core'
import MultipleMaterialiFilters from '../../components/Planner/MultipleMaterialiFilters'
import { AgentiState } from '../AdminPreventiviApp/localstate'
import OrdersSelectAutoComplete from '../../components/OrdersSelectAutoComplete'

const qpList = {
  encode: (a) => a,
  decode: (a) => (Array.isArray(a) ? a : [a]).filter(Boolean),
}

const EMPTY_LIST = []

const BIG_PAGE_SIZE = {
  page_size: 1000,
}

const OrdineFornitoreRow = React.memo(
  ({ ordineFornitore, onStatoClicked, openUpdateModalOrdineFornitore, openDeleteModal }) => (
    <tr
      style={{
        // green very light background for 'ARRIVATO' state
        backgroundColor: ordineFornitore.stato === 'ARRIVATO' ? '#e6ffe6' : '',
      }}
    >
      <td>
        {PERMISSIONS.viewOrders && ordineFornitore.ordine_data ? (
          <Link to={`/ordini/${ordineFornitore.ordine_data.id}/fasi`}>
            {ordineFornitore.ordine_data.numero_commessa}
          </Link>
        ) : ordineFornitore.ordine ? (
          <span>{ordineFornitore.ordine_data.numero_commessa}</span>
        ) : (
          <span>
            <i className="fa fa-times text-danger" />
          </span>
        )}{' '}
        -{' '}
        {ordineFornitore.ordine_data && ordineFornitore.ordine_data.cliente ? (
          ordineFornitore.ordine_data.cliente.nome
        ) : (
          <span>
            <i className="fa fa-times text-danger" />
          </span>
        )}
      </td>
      <td>{ordineFornitore?.ordine_data?.progetto}</td>
      <td>
        {ordineFornitore.ordine_data ? (
          ordineFornitore.ordine_data.riferimento
        ) : (
          <span>
            <i className="fa fa-times text-danger" />
          </span>
        )}
      </td>
      <td>
        {ordineFornitore.ordine_data && ordineFornitore.ordine_data.cliente ? (
          ordineFornitore.ordine_data.cliente.nome
        ) : (
          <span>
            <i className="fa fa-times text-danger" />
          </span>
        )}
      </td>
      <td className="text-nowrap">
        {ordineFornitore.ordine_data ? (
          ordineFornitore.ordine_data?.agente_data?.user?.first_name +
          ' ' +
          ordineFornitore.ordine_data?.agente_data?.user?.last_name
        ) : (
          <div />
        )}
      </td>
      <td className="text-nowrap">
        {ordineFornitore.ordine_data ? (
          ordineFornitore.ordine_data?.agente_data?.tipo_agente
        ) : (
          <div />
        )}
      </td>
      <td>
        {ordineFornitore.numero_documento
          ? ordineFornitore.numero_documento
          : ''}
      </td>
      <td>{moment(ordineFornitore.data_inserimento).format('YYYY-MM-DD')}</td>
      <td>
        {ordineFornitore.ordine_data ? (
          ordineFornitore.ordine_data.data_consegna
        ) : (
          <span>
            <i className="fa fa-times text-danger" />
          </span>
        )}
      </td>
      <td>
        {ordineFornitore.data_ordine
          ? moment(ordineFornitore.data_ordine).format('YYYY-MM-DD')
          : ''}
      </td>
      <td>
        {ordineFornitore.data_consegna
          ? moment(ordineFornitore.data_consegna).format('YYYY-MM-DD')
          : ''}
      </td>
      <td>
        {ordineFornitore.data_arrivo
          ? moment(ordineFornitore.data_arrivo).format('YYYY-MM-DD')
          : ''}
      </td>
      <td>
        <span>{ordineFornitore.fornitore_data.nome}</span>
      </td>
      <td className="text-capitalize">{ordineFornitore.tipologia}</td>
      <td>
        <div className="d-flex align-items-center">
          {ordineFornitore.stato}
          <Button
            onClick={() => onStatoClicked(ordineFornitore)}
            color="success"
            outline
            size="sm"
            className="ml-1"
          >
            <i className={`fas fa-edit`}></i>
          </Button>
        </div>
      </td>
      <td>
        {ordineFornitore.rilievo && ordineFornitore.rilievo === 'DA_FARE' ? (
          <span className="badge badge-warning">DA FARE</span>
        ) : ordineFornitore.rilievo && ordineFornitore.rilievo === 'FATTO' ? (
          <span className="badge badge-success">FATTO</span>
        ) : (
          <span className="badge badge-secondary">N/A</span>
        )}
      </td>
      <td>
        {ordineFornitore.co && ordineFornitore.co === 'DA_FARE' ? (
          <span className="badge badge-warning">DA FARE</span>
        ) : ordineFornitore.co && ordineFornitore.co === 'INVIATA' ? (
          <span className="badge badge-success">INVIATA</span>
        ) : (
          <span className="badge badge-secondary">N/A</span>
        )}
      </td>
      <td className="text-center">
        {ordineFornitore.ordine && (
          <>
            {!ordineFornitore.email_pdf ? (
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.stopPropagation()
                }}
                href={`/api/planner/ordini-fornitore/${ordineFornitore.id}/pdf/`}
              >
                <i className="fas fa-file-pdf-o mr-2 text-danger" />
              </a>
            ) : (
              <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.stopPropagation()
                }}
                href={ordineFornitore.email_pdf}
              >
                <i className="fas fa-file-pdf-o mr-2 text-danger" />
              </a>
            )}
          </>
        )}
      </td>
      <td>
        <ul>
          {ordineFornitore.allegati_data.map((allegato) => (
            <li key={allegato.id}>
              <a href={allegato.allegato}>
                {allegato.original_name || 'Allegato'}
              </a>
            </li>
          ))}
        </ul>
      </td>
      <td>{ordineFornitore.note}</td>
      <td>
        {ordineFornitore.magazzino ? (
          <span className="text-capitalize">{ordineFornitore.magazzino}</span>
        ) : (
          <span className="text-capitalize">N/A</span>
        )}
      </td>
      <td>{ordineFornitore.mittente || ''}</td>
      <td>
        {ordineFornitore.sottoconto_data ? (
          <span className="text-capitalize">
            {ordineFornitore.sottoconto_data.nome}
          </span>
        ) : (
          <span className="text-capitalize">N/A</span>
        )}
      </td>
      <td>
        {ordineFornitore.bu_data ? (
          <span className="text-capitalize">
            {ordineFornitore.bu_data.nome}
          </span>
        ) : (
          <span className="text-capitalize">N/A</span>
        )}
      </td>
      <td>{ordineFornitore.industriale}</td>
      <td>{ordineFornitore.diretto}</td>
      <td>{ordineFornitore.costi}</td>
      <td>
        {ordineFornitore.numero_ddt ? ordineFornitore.numero_ddt : ''}
      </td>
      <td>
        {ordineFornitore.avanzamento_commerciale ? 'SI' : 'NO'}
      </td>
      {PERMISSIONS.adminOrders && (
        <td>
          {ordineFornitore.costo_materiale
            ? ordineFornitore.costo_materiale.toFixed(2)
            : ''}
        </td>
      )}
      {PERMISSIONS.adminOrders && (
        <td>
          {ordineFornitore.vendita_materiale
            ? ordineFornitore.vendita_materiale.toFixed(2)
            : ''}
        </td>
      )}
      {PERMISSIONS.adminOrders && (
        <td>
          {ordineFornitore.vendita_materiale &&
            ordineFornitore.costo_materiale && (
              <span>
                {ordineFornitore.vendita_materiale -
                  ordineFornitore.costo_materiale}
              </span>
            )}
        </td>
      )}
      {PERMISSIONS.adminOrders && (
        <td>
          {ordineFornitore.vendita_materiale &&
            ordineFornitore.costo_materiale && (
              <span>
                {(
                  ((ordineFornitore.vendita_materiale -
                    ordineFornitore.costo_materiale) /
                    ordineFornitore.vendita_materiale) *
                  100
                ).toFixed(2)}
                %
              </span>
            )}
        </td>
      )}
      <td>
        <span
          onClick={() => {
            openUpdateModalOrdineFornitore(ordineFornitore)
          }}
          className="pointer"
        >
          <i
            title="Modifica ordine fornitore"
            className="fas fa-pencil-alt text-warning"
          />
        </span>
        <span className="ml-3">
          <i
            onClick={() => openDeleteModal(ordineFornitore)}
            title="Elimina ordine fornitore"
            className="fas fa-trash-alt text-danger pointer"
          />
        </span>
      </td>
    </tr>
  )
)

const FilterRow = ({
  filters,
  onFilterChange,
  onFiltersChange,
  onFilterChangeDebounced,
  totals,
}) => {
  const {
    materiali,
    valoriStato,
    buList,
    sottoconti: sottocontiList,
  } = useContext(ConfigPlannerContext)
  const [{ data: agenti }] = useRunRj(AgentiState)
  const statiOrdine = valoriStato.ordine_fornitore || EMPTY_LIST
  const bu = buList || EMPTY_LIST
  const sottoconti = sottocontiList || EMPTY_LIST
  return (
    <tr>
      <th className="text-nowrap">
        <OrdersSelectAutoComplete
          value={filters.ordine}
          hasValue
          debounceTimeout={150}
          loadOptionsOnMenuOpen
          onChange={(ordine) => {
            if (ordine) {
              onFiltersChange({ ordine: ordine.id })
            } else {
              onFiltersChange({ ordine: '' })
            }
          }}
          noOptionsMessage={() => 'Nessun ordine trovato'}
          loadingMessage={() => 'Caricamento ordini...'}
          placeholder={'Filtra per ordine'}
          isClearable={true}
          name={'ordine'}
          additional={{
            page: 1,
          }}
        />
      </th>
      <th>
        <input
          className="form-control"
          type="text"
          name="progetto"
          value={filters.progetto}
          onChange={onFilterChangeDebounced}
        />
      </th>
      <th>
        <input
          className="form-control"
          type="text"
          name="riferimento"
          value={filters.riferimento}
          onChange={onFilterChangeDebounced}
        />
      </th>
      <th>
        <input
          autoComplete="off"
          className="form-control"
          type="text"
          name="cliente"
          value={filters.cliente}
          onChange={onFilterChangeDebounced}
        />
      </th>
      {PERMISSIONS.viewAgenteOnOrders && (
        <th className="text-nowrap">
          <select
            name="agente"
            value={filters.agente}
            className="form-control form-control-sm"
            onChange={onFilterChange}
          >
            <option value=""></option>
            <option value="null">Nessun agente settato</option>
            {agenti &&
              agenti.map((agente) => (
                <option key={agente.id} value={agente.id}>
                  {agente.user.first_name} {agente.user.last_name}
                </option>
              ))}
          </select>
        </th>
      )}
      <th>
        <select
          name="tipo_agente"
          className="form-control form-control-sm"
          onChange={onFilterChange}
          value={filters.tipo_agente}
        >
          <option value={''}>Filtra per tipo agente</option>
          <option value={'B2C'}>B2C</option>
          <option value={'B2B'}>B2B</option>
          <option value={'B2C*s'}>B2C*s</option>
        </select>
      </th>
      <th></th>
      <th>
        <DateRangeQsFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
          startField="from_data_inserimento"
          endField="to_data_inserimento"
          withPortal={true}
          customArrowIcon={<div />}
          small={false}
          noBorder
        />
      </th>
      <th>
        <DateRangeQsFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
          startField="from_data_consegna"
          endField="to_data_consegna"
          withPortal={true}
          customArrowIcon={<div />}
          small={false}
          noBorder
        />
      </th>
      <th>
        <DateRangeQsFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
          startField="from_data_ordine_fornitore"
          endField="to_data_ordine_fornitore"
          withPortal={true}
          customArrowIcon={<div />}
          small={false}
          noBorder
        />
      </th>
      <th>
        <DateRangeQsFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
          startField="from_data_consegna_fornitore"
          endField="to_data_consegna_fornitore"
          withPortal={true}
          customArrowIcon={<div />}
          small={false}
          noBorder
        />
      </th>
      <th>
        <DateRangeQsFilter
          filters={filters}
          onFiltersChange={onFiltersChange}
          startField="from_data_arrivo"
          endField="to_data_arrivo"
          withPortal={true}
          customArrowIcon={<div />}
          small={false}
          noBorder
        />
      </th>
      <th>
        <input
          className="form-control"
          type="text"
          name="fornitore_nome"
          value={filters.fornitore_nome}
          onChange={onFilterChangeDebounced}
        />
      </th>
      <th>
        <select
          value={filters.tipologia}
          onChange={onFilterChange}
          name="tipologia"
          className="form-control"
        >
          <option value=""></option>
          <option value="vetro">Vetro</option>
          <option value="legno">Legno</option>
          <option value="verniciatura">Verniciatura</option>
          <option value="telai">Telai</option>
          {materiali.map((materiale) => (
            <option key={materiale} value={materiale}>
              {materiale}
            </option>
          ))}
        </select>
      </th>
      <th>
        <select
          value={filters.stato}
          onChange={onFilterChange}
          name="stato"
          className="form-control"
        >
          <option value=""></option>
          {statiOrdine.map((stato) => (
            <option value={stato.nome} key={stato.nome}>
              {stato.nome}
            </option>
          ))}
        </select>
      </th>
      <th>
        <select
          value={filters.rilievo}
          onChange={onFilterChange}
          name="rilievo"
          className="form-control"
        >
          <option value=""></option>
          <option value="DA_FARE">DA FARE</option>
          <option value="FATTO">FATTO</option>
        </select>
      </th>
      <th>
        <select
          value={filters.co}
          onChange={onFilterChange}
          name="co"
          className="form-control"
        >
          <option value=""></option>
          <option value="DA_FARE">DA FARE</option>
          <option value="INVIATA">INVIATA</option>
        </select>
      </th>
      <th></th>
      <th></th>
      <th>
        <input
          className="form-control"
          type="text"
          name="note"
          value={filters.note}
          onChange={onFilterChangeDebounced}
        />
      </th>
      <th>
        <select
          value={filters.magazzino}
          onChange={onFilterChange}
          name="magazzino"
          className="form-control"
        >
          <option value=""></option>
          <option value="QR">QR</option>
          <option value="RENIS">RENIS</option>
          <option value="CONSEGNATO AL CLIENTE">CONSEGNATO AL CLIENTE</option>
        </select>
      </th>
      <th></th>
      <th>
        <select
          value={filters.sottoconto}
          onChange={onFilterChange}
          name="sottoconto"
          className="form-control"
        >
          <option value=""></option>
          {Object.entries(sottoconti).map(([id, nome]) => (
            <option key={id} value={id}>
              {nome}
            </option>
          ))}
        </select>
      </th>

      <th>
        <select
          value={filters.bu}
          onChange={onFilterChange}
          name="bu"
          className="form-control"
        >
          <option value=""></option>
          {Object.entries(bu).map(([id, nome]) => (
            <option key={id} value={id}>
              {nome}
            </option>
          ))}
        </select>
      </th>
      <th>
        <select
          value={filters.industriale}
          onChange={onFilterChange}
          name="industriale"
          className="form-control"
        >
          <option value=""></option>
          <option value="Industriale">Industriale</option>
          <option value="Non Industriale">Non Industriale</option>
        </select>
      </th>
      <th>
        <select
          value={filters.diretto}
          onChange={onFilterChange}
          name="diretto"
          className="form-control"
        >
          <option value=""></option>
          <option value="Diretto">Diretto</option>
          <option value="Indiretto">Indiretto</option>
        </select>
      </th>
      <th>
        <select
          value={filters.costi}
          onChange={onFilterChange}
          name="costi"
          className="form-control"
        >
          <option value=""></option>
          <option value="CF">Costi fissi</option>
          <option value="CV">Costi variabili</option>
        </select>

      </th>
      <th></th>
      <th>
        <select
          value={filters.avanzamento_commerciale}
          onChange={onFilterChange}
          name="avanzamento_commerciale"
          className="form-control"
        >
          <option value=""></option>
          <option value="true">Con avanzamento commerciale</option>
          <option value="false">Senza avanzamento commerciale</option>
        </select>
      </th>
      {PERMISSIONS.adminOrders && (
        <th>
          <div className="badge badge-info">
            {totals && totals.costo ? totals.costo.toFixed(2) : '0.00'}
          </div>
        </th>
      )}
      {PERMISSIONS.adminOrders && (
        <th>
          <div className="badge badge-info">
            {totals && totals.vendita ? totals.vendita.toFixed(2) : '0.00'}
          </div>
        </th>
      )}
      {PERMISSIONS.adminOrders && (
        <th>
          <div className="badge badge-info">
            {totals && totals.vendita && totals.costo
              ? (totals.vendita - totals.costo).toFixed(2)
              : '0.00'}
          </div>
        </th>
      )}
      {PERMISSIONS.adminOrders && (
        <th>
          <div className="badge badge-info">
            {totals && totals.vendita && totals.costo
              ? (
                  ((totals.vendita - totals.costo) / totals.vendita) *
                  100
                ).toFixed(2) + '%'
              : '0.00%'}
          </div>
        </th>
      )}
      <th></th>
    </tr>
  )
}

export default function OrdiniFornitore() {
  const [
    { list: ordiniFornitore, pagination, updatingStato, loading, totals },

    { page, ...filters },
    {
      onFilterChange,
      onFiltersChange,
      onFilterChangeDebounced,
      goToPage,
      updateStato,
      updateOrdineFornitore,
      deleteOrdineFornitore,
      addOrdineFornitoreWithoutInsert,
      refresh,
    },
  ] = useDataTable(OrdiniFornitoreState, () => ({
    fornitore_nome: '',
    ordine: '',
    progetto: '',
    tipologia: '',
    rilievo: '',
    co: '',
    magazzino: '',
    agente: '',
    stato: '',
    note: '',
    cliente: '',
    from_data_consegna: '',
    to_data_consegna: '',
    from_data_consegna_fornitore: '',
    to_data_consegna_fornitore: '',
    from_data_arrivo: '',
    to_data_arrivo: '',
    from_data_ordine_fornitore: '',
    to_data_ordine_fornitore: '',
    from_data_inserimento: '',
    to_data_inserimento: '',
    ordering: '',
    riferimento: '',
    numero_commessa: '',
    tipo_agente: '',
    materiali: {
      value: [],
      encdec: qpList,
    },
    stati_materiali: {
      value: [],
      encdec: qpList,
    },
    sottoconto: '',
    bu: '',
    industriale: '',
    diretto: '',
    costi: '',
    avanzamento_commerciale: '',
  }))

  const columnProps = {
    value: filters.ordering,
    onChange: (value) => onFilterChange(value, 'ordering'),
  }

  const { valoriStato, materiali, fasiScheduler } =
    useContext(ConfigPlannerContext)

  const statiOrdineFornitore = valoriStato.ordine_fornitore || EMPTY_LIST

  const [{ fornitori }, { run: fetchFornitori }] = useRunRj(FornitoriState, [
    BIG_PAGE_SIZE,
  ])
  const fornitoriActions = useMemo(
    () => ({
      refreshFornitori: fetchFornitori.curry(BIG_PAGE_SIZE),
    }),
    [fetchFornitori]
  )

  const tipologie = useMemo(() => {
    const fasiNeeded = getFasiNeededByOrder(null, fasiScheduler)

    const listTipologieFromFasi = fasiScheduler.reduce((list, fase) => {
      if (fase.with_fornitore && fasiNeeded[fase.nome_fase]) {
        list.push(fase.nome_fase)
      }
      return list
    }, [])
    return listTipologieFromFasi.concat(materiali)
  }, [fasiScheduler, materiali])

  const [modalStato, setModalStato] = useState(null)
  const toggleModalStato = useCallback(() => setModalStato(null), [])

  const [modalDelete, setModalDelete] = useState(null)
  const toggleModalDelete = useCallback(() => setModalDelete(null), [])

  const [modalOrderFornitore, setModalOrderFornitore] = useState({
    operation: null,
    record: null,
  })
  const closeModalOrderFornitore = useCallback(() => {
    setModalOrderFornitore({ operation: null, record: null })
  }, [])
  const openCreateModalOrdineFornitore = useCallback(() => {
    setModalOrderFornitore({ operation: 'CREATE', record: null })
  }, [])
  const openUpdateModalOrdineFornitore = useCallback((record) => {
    setModalOrderFornitore({ operation: 'UPDATE', record })
  }, [])

  const coreMateriali = useMemo(
    () => fasiScheduler.filter((f) => f.with_fornitore).map((f) => f.nome_fase),
    [fasiScheduler]
  )

  const materialiOptions = useMemo(
    () => coreMateriali.concat(materiali),
    [coreMateriali, materiali]
  )

  const makeLabelMateriale = useCallback((m) => m.toUpperCase(), [])

  const valoriStatoOptionsMateriali = useMemo(() => {
    return valoriStato.ordine_fornitore.map((c) => ({
      value: c.nome,
      label: c.nome,
    }))
  }, [valoriStato])

  const [{ data }, { run: runDownloadOrdiniFornitori }] = useRj(
    DownloadOrdiniFornitori
  )

  const filtersToUse = useMemo(() => {
    return {
      ...filters,
    }
  }, [filters])

  const [isDownloading, setIsDownloading] = useState(false)

  return (
    <div className="container-fluid">
      <div className="d-flex" style={{ zIndex: 9999 }}>
        <div className="flex-1">
          <MultipleMaterialiFilters
            makeLabelMateriale={makeLabelMateriale}
            placeholderMateriale={'-- Tipologia --'}
            filters={filters}
            valoriStatoOptions={valoriStatoOptionsMateriali}
            onFiltersChange={onFiltersChange}
            materialiOptions={materialiOptions}
          />
        </div>
        <div className="text-right">
          <Button
            disabled={isDownloading}
            onClick={() => {
              setIsDownloading(true)
              runDownloadOrdiniFornitori
                .onSuccess((data) => {
                  // trigger download blob file

                  const url = window.URL.createObjectURL(new Blob([data]))
                  const link = document.createElement('a')
                  link.href = url
                  const date = new Date()
                  link.setAttribute(
                    'download',
                    `ordini_fornitori_${date.toISOString()}.xlsx`
                  )
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                  setIsDownloading(false)
                })
                .run(filtersToUse)
            }}
            size="sm"
            className="mt-2 mr-2"
            outline
            color="primary"
          >
            {isDownloading && (
              <CircularProgress size={10} color="primary" className="mr-2" />
            )}
            <i className="fas fa-file-excel"></i> Esporta in Excel
          </Button>
          <Button
            onClick={() => {
              openCreateModalOrdineFornitore()
            }}
            size="sm"
            className="mt-2"
            outline
            color="secondary"
          >
            <i className="fas fa-plus-circle"></i> Aggiungi ordine fornitore
          </Button>
        </div>
      </div>
      {ordiniFornitore === null && loading && (
        <div className="text-center mt-4">
          <CircularProgress color="primary" />
        </div>
      )}
      {ordiniFornitore && (
        <>
          <div
            className="mt-2 mb-2"
            style={{
              height: 'calc(100vh - 180px)',
              overflowY: 'auto',
              overflowX: 'auto',
              width: 'calc(100vw - 30px)',
            }}
          >
            <table
              cellSpacing={0}
              className="table table-bordered table-orders"
            >
              <thead
                className="position-sticky"
                style={{ top: 0, background: 'white', zIndex: 0 }}
              >
                <FilterRow
                  filters={filters}
                  onFilterChange={onFilterChange}
                  onFiltersChange={onFiltersChange}
                  onFilterChangeDebounced={onFilterChangeDebounced}
                  totals={totals}
                />
                <tr>
                  <Column {...columnProps} field="ordine__numero_commessa">
                    Ordine
                  </Column>
                  <Column {...columnProps} field="ordine__progetto">
                    Progetto
                  </Column>
                  <Column {...columnProps} field="ordine__riferimento">
                    Ordine Riferimento
                  </Column>
                  <Column {...columnProps} field="ordine__cliente__nome">
                    Cliente
                  </Column>
                  <Column
                    {...columnProps}
                    field="ordine__agente__user__first_name"
                  >
                    Agente
                  </Column>
                  <Column {...columnProps} field="ordine__agente__tipo_agente">
                    Tipo BU
                  </Column>
                  <Column {...columnProps} field="numero_documento">
                    Numero Documento
                  </Column>
                  <Column {...columnProps} field="data_inserimento">
                    Data Inserimento
                  </Column>
                  <Column {...columnProps} field="ordine__data_consegna">
                    Data Approntamento
                  </Column>
                  <Column {...columnProps} field="data_ordine">
                    Data Ordine
                  </Column>
                  <Column {...columnProps} field="data_consegna">
                    Data Consegna prevista
                  </Column>
                  <Column {...columnProps} field="data_arrivo">
                    Data Consegna effettiva
                  </Column>
                  <Column {...columnProps} field="fornitore__nome">
                    Fornitore
                  </Column>
                  <Column {...columnProps} field="tipologia">
                    Tipologia
                  </Column>
                  <Column {...columnProps} field="stato">
                    Stato
                  </Column>
                  <Column {...columnProps} field="rilievo">
                    Rilievo
                  </Column>
                  <Column {...columnProps} field="co">
                    CO
                  </Column>
                  <th>PDF</th>
                  <th>Allegati</th>
                  <th>Note</th>
                  <th>Dovè</th>
                  <Column {...columnProps} field="mittente">
                    Mittente
                  </Column>
                  <Column {...columnProps} field="sottoconto">
                    Sottoconto
                  </Column>
                  <Column {...columnProps} field="bu">
                    BU
                  </Column>
                  <Column {...columnProps} field="industriale">
                    Ind/Non Ind
                  </Column>
                  <Column {...columnProps} field="diretto">
                    Dir/Ind
                  </Column>
                  <Column {...columnProps} field="costi">
                    CF/CV
                  </Column>
                  <Column {...columnProps} field="numero_ddt">
                    Numero DDT
                  </Column>
                  <Column {...columnProps} field="avanzamento_commerciale">
                    Avanzam. Comm.
                  </Column>
                  {PERMISSIONS.adminOrders && (
                    <Column {...columnProps} field="costo_materiale">
                      Costo
                    </Column>
                  )}
                  {PERMISSIONS.adminOrders && (
                    <Column {...columnProps} field="vendita_materiale">
                      Vendita
                    </Column>
                  )}
                  {PERMISSIONS.adminOrders && <th>Valore aggiunto</th>}
                  {PERMISSIONS.adminOrders && <th>Perc.</th>}
                  <th>Azioni</th>
                </tr>
              </thead>
              <tbody>
                {ordiniFornitore.map((ordineFornitore) => (
                  <OrdineFornitoreRow
                    openUpdateModalOrdineFornitore={
                      openUpdateModalOrdineFornitore
                    }
                    onStatoClicked={setModalStato}
                    key={ordineFornitore.id}
                    ordineFornitore={ordineFornitore}
                    openDeleteModal={setModalDelete}
                  />
                ))}
              </tbody>
            </table>
          </div>

          <Paginator
            numPages={pagination.numPages}
            currentPage={page}
            goToPage={goToPage}
          />
        </>
      )}
      <ModalUpdateStato
        title={
          modalStato && (
            <span>
              Modifica stato ordine fornitore{' '}
              <span className="text-capitalize">{modalStato.tipologia}</span>{' '}
              <span>{modalStato.fornitore_data.nome}</span>
              {modalStato.ordine
                ? ` x Ordine ${modalStato.ordine_data.numero_commessa}`
                : ''}
            </span>
          )
        }
        initialStato={modalStato && modalStato.stato}
        required
        toggle={toggleModalStato}
        isOpen={modalStato !== null}
        saving={updatingStato}
        stati={statiOrdineFornitore}
        onSave={(stato, dataArrivo) => {
          updateStato
            .onSuccess(() => {
              refresh()
              toggleModalStato()
            })
            .run(modalStato, stato, dataArrivo)
        }}
      />
      <Modal
        size="md"
        toggle={toggleModalDelete}
        isOpen={modalDelete !== null}
      >
        <ModalHeader toggle={toggleModalDelete}>
          Eliminazione Ordine Fornitore
        </ModalHeader>
        <ModalBody>
          Sei sicuro di voler eliminare l'ordine fornitore{' '}
          {modalDelete && (
            <strong>
              <span className="text-capitalize">
                {modalDelete.tipologia}
              </span>{' '}
              per fornitore {modalDelete.fornitore_data.nome}
              {modalDelete.ordine
                ? ` x Ordine ${modalDelete.ordine_data.numero_commessa}`
                : ''}
            </strong>
          )}
          ?
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            outline
            onClick={toggleModalDelete}
            size="sm"
          >
            Annulla
          </Button>{' '}
          <Button
            color="danger"
            outline
            onClick={() => {
              deleteOrdineFornitore
                .onSuccess(() => {
                  refresh()
                  toggleModalDelete()
                })
                .run(modalDelete)
            }}
            size="sm"
          >
            Elimina
          </Button>
        </ModalFooter>
      </Modal>
      <ContextFornitoriActions.Provider value={fornitoriActions}>
        <ContextFornitori.Provider value={fornitori || EMPTY_LIST}>
          <Modal
            size="lg"
            toggle={closeModalOrderFornitore}
            isOpen={
              modalOrderFornitore.operation !== null &&
              (modalOrderFornitore.operation === 'UPDATE' ||
                modalOrderFornitore.operation === 'CREATE')
            }
          >
            <ModalHeader toggle={closeModalOrderFornitore}>
              {modalOrderFornitore &&
                modalOrderFornitore.operation === 'UPDATE' &&
                'Modifica Ordine Fornitore'}
              {modalOrderFornitore &&
                modalOrderFornitore.operation === 'CREATE' &&
                'Aggiungi Ordine Fornitore'}
            </ModalHeader>
            <OrderFornitoreForm
              tipologie={tipologie}
              showOrder
              save={(data) => {
                console.log('save', data)
                if (modalOrderFornitore.record) {
                  return updateOrdineFornitore
                    .onSuccess(() => {
                      closeModalOrderFornitore()
                    })
                    .asPromise(data)
                } else {
                  return addOrdineFornitoreWithoutInsert
                    .onSuccess(() => {
                      refresh()
                      closeModalOrderFornitore()
                    })
                    .asPromise(data)
                }
              }}
              toggle={closeModalOrderFornitore}
              orderFornitore={modalOrderFornitore.record}
              inModal
            />
          </Modal>
        </ContextFornitori.Provider>
      </ContextFornitoriActions.Provider>
    </div>
  )
}
